import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8673c2f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onDragover", "onDragleave", "onDrop"]
const _hoisted_2 = { class: "file-upload-area" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "mt-2 text-center file-upload-buttons" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-8673c2f5><circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"var(--subtle-fg)\" data-v-8673c2f5></circle><path d=\"M13.5 22V19\" stroke=\"var(--primary)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8673c2f5></path><path d=\"M16.5 22V19\" stroke=\"var(--primary)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8673c2f5></path><path d=\"M10.5 22H19.5\" stroke=\"var(--primary)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8673c2f5></path><path d=\"M7.5 16H22.5\" stroke=\"var(--primary)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8673c2f5></path><path d=\"M21 8H9C8.17157 8 7.5 8.67157 7.5 9.5V17.5C7.5 18.3284 8.17157 19 9 19H21C21.8284 19 22.5 18.3284 22.5 17.5V9.5C22.5 8.67157 21.8284 8 21 8Z\" stroke=\"var(--primary)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8673c2f5></path></svg>", 1)
const _hoisted_7 = ["multiple", "accept"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "15",
    cy: "15",
    r: "15",
    fill: "var(--subtle-fg)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.0245 11.5H8C7.72386 11.5 7.5 11.7239 7.5 12V20C7.5 21.1046 8.39543 22 9.5 22H20.5C21.6046 22 22.5 21.1046 22.5 20V14.5C22.5 14.2239 22.2761 14 22 14H15.2169C15.0492 14 14.8926 13.9159 14.8 13.776L13.4414 11.724C13.3488 11.5841 13.1922 11.5 13.0245 11.5Z",
    stroke: "var(--primary)",
    "stroke-miterlimit": "10",
    "stroke-linecap": "square"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.87939 9.5V8.5C8.87939 8.22386 9.10325 8 9.37939 8H20.6208C20.8969 8 21.1208 8.22386 21.1208 8.5V12",
    stroke: "var(--primary)",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-8673c2f5><circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"var(--subtle-fg)\" data-v-8673c2f5></circle><path d=\"M12.0469 17.9543L17.9558 12.0454\" stroke=\"var(--primary)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8673c2f5></path><path d=\"M13.8184 11.4547L15.7943 9.47873C16.4212 8.85205 17.2714 8.5 18.1578 8.5C19.0443 8.5 19.8945 8.85205 20.5214 9.47873V9.47873C21.1481 10.1057 21.5001 10.9558 21.5001 11.8423C21.5001 12.7287 21.1481 13.5789 20.5214 14.2058L18.5455 16.1818\" stroke=\"var(--primary)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8673c2f5></path><path d=\"M11.4547 13.8184L9.47873 15.7943C8.85205 16.4212 8.5 17.2714 8.5 18.1578C8.5 19.0443 8.85205 19.8945 9.47873 20.5214V20.5214C10.1057 21.1481 10.9558 21.5001 11.8423 21.5001C12.7287 21.5001 13.5789 21.1481 14.2058 20.5214L16.1818 18.5455\" stroke=\"var(--primary)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8673c2f5></path></svg>", 1)
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "15",
    cy: "15",
    r: "15",
    fill: "var(--subtle-fg)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.5 10.5H9.5C8.67157 10.5 8 11.1716 8 12V20C8 20.8284 8.67157 21.5 9.5 21.5H20.5C21.3284 21.5 22 20.8284 22 20V12C22 11.1716 21.3284 10.5 20.5 10.5H18.5L17.3 8.9C17.1111 8.64819 16.8148 8.5 16.5 8.5H13.5C13.1852 8.5 12.8889 8.64819 12.7 8.9L11.5 10.5Z",
    stroke: "var(--primary)",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "15",
    cy: "16",
    r: "2.5",
    stroke: "var(--primary)"
  })
], -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30"
}, [
  /*#__PURE__*/_createElementVNode("image", {
    href: "/assets/frappe/icons/social/google_drive.svg",
    width: "30",
    height: "30"
  })
], -1 /* HOISTED */))
const _hoisted_12 = { class: "text-muted text-medium text-center" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "file-preview-area" }
const _hoisted_15 = {
  key: 0,
  class: "file-preview-container"
}
const _hoisted_16 = {
  key: 1,
  class: "flex align-items-center justify-content-end"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 3,
  class: "flex align-center my-2"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "file-uploader",
    onDragover: _withModifiers($setup.dragover, ["prevent"]),
    onDragleave: _withModifiers($setup.dragleave, ["prevent"]),
    onDrop: _withModifiers($setup.dropfiles, ["prevent"])
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (!$setup.is_dragging)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.__("Drag and drop files here or upload from")), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "btn btn-file-upload",
                onClick: $setup.browse_files
              }, [
                _hoisted_6,
                _createElementVNode("div", null, _toDisplayString(_ctx.__("My Device")), 1 /* TEXT */)
              ]),
              _createElementVNode("input", {
                type: "file",
                class: "hidden",
                ref: "file_input",
                onChange: $setup.on_file_input,
                multiple: $props.allow_multiple,
                accept: ($props.restrictions.allowed_file_types || []).join(', ')
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7),
              (!$props.disable_file_browser)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-file-upload",
                    onClick: _cache[0] || (_cache[0] = $event => ($setup.show_file_browser = true))
                  }, [
                    _hoisted_8,
                    _createElementVNode("div", null, _toDisplayString(_ctx.__("Library")), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              ($props.allow_web_link)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-file-upload",
                    onClick: _cache[1] || (_cache[1] = $event => ($setup.show_web_link = true))
                  }, [
                    _hoisted_9,
                    _createElementVNode("div", null, _toDisplayString(_ctx.__("Link")), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.allow_take_photo)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-file-upload",
                    onClick: $setup.capture_image
                  }, [
                    _hoisted_10,
                    _createElementVNode("div", null, _toDisplayString(_ctx.__("Camera")), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              ($props.allow_google_drive && $setup.google_drive_settings.enabled)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: "btn btn-file-upload",
                    onClick: $setup.show_google_drive_picker
                  }, [
                    _hoisted_11,
                    _createElementVNode("div", null, _toDisplayString(_ctx.__("Google Drive")), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_12, _toDisplayString($props.upload_notes), 1 /* TEXT */)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.__("Drop files here")), 1 /* TEXT */))
    ], 512 /* NEED_PATCH */), [
      [_vShow, $setup.files.length === 0 && !$setup.show_file_browser && !$setup.show_web_link]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_14, [
      (!$setup.show_image_cropper)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.files, (file, i) => {
              return (_openBlock(), _createBlock($setup["FilePreview"], {
                key: file.name,
                file: file,
                allow_toggle_private: $props.allow_toggle_private && !$props.forced_file_visibility,
                allow_toggle_optimize: $props.allow_toggle_optimize,
                onRemove: $event => ($setup.remove_file(file)),
                onToggle_private: $event => (file.private = !file.private),
                onToggle_optimize: $event => (file.optimize = !file.optimize),
                onToggle_image_cropper: $event => ($setup.toggle_image_cropper(i))
              }, null, 8 /* PROPS */, ["file", "allow_toggle_private", "allow_toggle_optimize", "onRemove", "onToggle_private", "onToggle_optimize", "onToggle_image_cropper"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      ($props.show_upload_button && $setup.currently_uploading === -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-sm margin-right",
              onClick: _cache[2] || (_cache[2] = () => $setup.upload_files())
            }, [
              ($setup.files.length === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.__("Upload file")), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.__("Upload {0} files", [$setup.files.length])), 1 /* TEXT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */), [
      [_vShow, $setup.files.length && !$setup.show_file_browser && !$setup.show_web_link]
    ]),
    ($setup.show_image_cropper && $setup.wrapper_ready)
      ? (_openBlock(), _createBlock($setup["ImageCropper"], {
          key: 0,
          file: $setup.files[$setup.crop_image_with_index],
          fixed_aspect_ratio: $props.restrictions.crop_image_aspect_ratio,
          onToggle_image_cropper: _cache[3] || (_cache[3] = $event => ($setup.toggle_image_cropper(-1))),
          onUpload_after_crop: _cache[4] || (_cache[4] = $event => ($setup.trigger_upload = true))
        }, null, 8 /* PROPS */, ["file", "fixed_aspect_ratio"]))
      : _createCommentVNode("v-if", true),
    ($setup.show_file_browser && !$props.disable_file_browser)
      ? (_openBlock(), _createBlock($setup["FileBrowser"], {
          key: 1,
          ref: "file_browser",
          onHideBrowser: _cache[5] || (_cache[5] = $event => ($setup.show_file_browser = false))
        }, null, 512 /* NEED_PATCH */))
      : _createCommentVNode("v-if", true),
    ($setup.show_web_link)
      ? (_openBlock(), _createBlock($setup["WebLink"], {
          key: 2,
          ref: "web_link",
          onHideWebLink: _cache[6] || (_cache[6] = $event => ($setup.show_web_link = false))
        }, null, 512 /* NEED_PATCH */))
      : _createCommentVNode("v-if", true),
    (
				$props.show_upload_button &&
				$setup.currently_uploading === -1 &&
				(($setup.show_file_browser && !$props.disable_file_browser) || $setup.show_web_link)
			)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("button", {
            class: "btn btn-primary btn-sm margin-right",
            onClick: _cache[7] || (_cache[7] = () => $setup.upload_files())
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.__("Select")), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1))
}